<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const ECharts = defineAsyncComponent(async () => {
  await import('./echarts-init')
  const m = await import('vue-echarts')
  return m.default || m
})

defineProps<{
  option: Record<string, unknown>
  autoresize?: boolean
  updateOptions?: { notMerge?: boolean; lazyUpdate?: boolean }
}>()
</script>

<template>
  <ECharts :option="option" :autoresize="autoresize" :update-options="updateOptions" />
</template>
